import type { CardInstance, Faction } from '../../types/kotch';
import { CARD_DEFINITIONS } from '../../data/kotch/cards';
import { FACTION_INFO } from '../../data/kotch/factionDecks';

interface DeckDisplayProps {
  deck: CardInstance[];
  faction: Faction | null;
  isOpponent?: boolean;
}

export default function DeckDisplay({ deck, faction, isOpponent = false }: DeckDisplayProps) {
  // Get top card category to show on back
  const topCard = deck[0];
  const topCardDef = topCard ? CARD_DEFINITIONS[topCard.definitionId] : null;
  const topCardCategory = topCardDef?.category || 'basic';

  const factionInfo = faction ? FACTION_INFO[faction] : null;

  return (
    <div className={`kotch-deck-display ${isOpponent ? 'opponent' : 'player'}`}>
      <div className={`kotch-deck-pile ${deck.length === 0 ? 'empty' : ''}`}>
        {deck.length > 0 ? (
          <>
            {/* Stack effect - show a few cards behind */}
            {deck.length > 2 && <div className="kotch-deck-card-back stack-3" />}
            {deck.length > 1 && <div className="kotch-deck-card-back stack-2" />}
            <div className={`kotch-deck-card-back ${topCardCategory}`}>
              {topCardCategory === 'special' && (
                <span className="kotch-deck-special-indicator">*</span>
              )}
            </div>
          </>
        ) : (
          <div className="kotch-deck-empty">Empty</div>
        )}
      </div>
      <div className="kotch-deck-info">
        <span className="kotch-deck-count">{deck.length}</span>
        {factionInfo && (
          <span
            className="kotch-deck-faction-badge"
            style={{ backgroundColor: factionInfo.themeColor }}
          >
            {factionInfo.name}
          </span>
        )}
      </div>
    </div>
  );
}
